import { useParams } from "react-router-dom";
import { useState, useEffect } from 'react';
// import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
// import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
// a11yDark, atomDark, base16AteliersulphurpoolLight, cb, coldarkCold, coldarkDark, coy, coyWithoutShadows, darcula, dark, dracula, duotoneDark,
// duotoneEarth, duotoneForest, duotoneLight, duotoneSea, duotoneSpace, funky, ghcolors, gruvboxDark, gruvboxLight, holiTheme, hopscotch,
// lucario, materialDark, materialLight, materialOceanic, nightOwl, nord, okaidia, oneDark, oneLight, pojoaque, prism, shadesOfPurple,
// solarizedDarkAtom, solarizedlight, synthwave84, tomorrow, twilight, vs, vscDarkPlus, xonokai, zTouch

function SinglePage() {
    
    const {id} = useParams();
    const [post, setPost] = useState(null);

    useEffect(() => {
        fetch(`http://wiki2.promoshoko.ru/wp-json/wp/v2/posts/${id}`)
        .then(res => res.json())
        .then(data => setPost(data))
      }, [id]);

    return (
      <>
        {post && (
            <>
                <h1><span>#h1</span> {post.title.rendered}</h1>
                {/* <SyntaxHighlighter style={dark} showLineNumbers wrapLongLines="true"> */}
                  <div dangerouslySetInnerHTML={{ __html: post.content.rendered}} />
                  {/* {post.content.rendered} */}
                {/* </SyntaxHighlighter> */}
            </>
        )}
      </>
     );
  }


//   <SyntaxHighlighter language="php"
//   style={darcula}
//   showLineNumbers={true}
//   >
//   {pre}
//   </SyntaxHighlighter>

  export default SinglePage;